import React, { FC } from 'react';
import styles from './StoreReadyStep.scss';
import { StoreReadyStepPreview } from './components/StoreReadyStepPreview';
import { StoreReadyStepContent } from './components/StoreReadyStepContent';

export const StoreReadyStep: FC = () => {
  return (
    <div className={styles.storeReadyStep}>
      <StoreReadyStepContent />
      <div className={styles.storeReadyStepSide}>
        <StoreReadyStepPreview />
      </div>
    </div>
  );
};
